import { Link } from 'react-router-dom';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import StatusChip from '../../../shared/components/Chips/StatusChip.component';
import { TableBodySkeleton } from '../../../shared/components/Tables/TableBodySkeleton.component';
import { ADMIN_USERS_APP_PATHS } from '../../constants/users-paths.constants';
import { UserContact } from '../../types/user.type';

type ContactsTableHeader = {
  key: string;
  label: string;
  minWidth: number;
  align: 'left' | 'center';
};

type Props = {
  contacts: UserContact[];
  isLoading: boolean;
  ariaLabel: string;
  maxHeight?: string;
};

const CONTACTS_TABLE_HEADERS: ContactsTableHeader[] = [
  { key: 'name', label: 'Nom', minWidth: 200, align: 'left' },
  { key: 'email', label: 'Email', minWidth: 250, align: 'left' },
  { key: 'status', label: 'Statut', minWidth: 100, align: 'center' },
];

const COLUMN_COUNT = CONTACTS_TABLE_HEADERS.length;

const SKELETON_ROWS = 3;

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.admin.primary.main,
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

function ContactRow({ contact }: { contact: UserContact }) {
  const classes = useStyles();

  return (
    <TableRow hover tabIndex={-1}>
      <TableCell align="left">
        <Link className={classes.link} to={ADMIN_USERS_APP_PATHS.USER_DETAILS(contact.id)}>
          {contact.firstname} {contact.lastname}
        </Link>
      </TableCell>
      <TableCell align="left">{contact.email || '-'}</TableCell>
      <TableCell align="center">
        <StatusChip isActive={contact.isActive} inactiveLabel="Désactivé" />
      </TableCell>
    </TableRow>
  );
}

export function UserContactsTable({ contacts, isLoading, ariaLabel, maxHeight = '74svh' }: Props) {
  return (
    <Paper>
      <TableContainer style={{ maxHeight }}>
        <Table stickyHeader aria-label={ariaLabel}>
          <TableHead>
            <TableRow>
              {CONTACTS_TABLE_HEADERS.map((header) => (
                <TableCell
                  key={header.key}
                  align={header.align}
                  style={{ minWidth: header.minWidth, fontWeight: 'bold' }}
                >
                  {header.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isLoading && <TableBodySkeleton rows={SKELETON_ROWS} columns={COLUMN_COUNT} />}
          {!isLoading && (
            <TableBody>
              {contacts.length === 0 && (
                <TableRow>
                  <TableCell colSpan={COLUMN_COUNT} align="center">
                    Aucun contact
                  </TableCell>
                </TableRow>
              )}
              {contacts.map((contact) => (
                <ContactRow key={contact.id} contact={contact} />
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </Paper>
  );
}
